<!-- This example requires Tailwind CSS v2.0+ -->
<template>
        <div>
            <div class="text-base font-medium text-gray-900">Добавить условие</div>

            <div class="mt-4 grid grid-cols-1 gap-y-6 sm:grid-cols-4 sm:gap-x-4">
                <div v-for="item in filteredTypes" :key="item.id" @click="toggleType(item)">
                    <div :class="[item.checked ? 'border-transparent' : 'border-gray-300', item.active ? 'border-indigo-500 ring-2 ring-indigo-500' : '', 'relative bg-white border rounded-lg shadow-sm p-4 flex cursor-pointer focus:outline-none']">
                        <div class="flex-1 flex">
                            <div class="flex">
                                <div class="flex-shrink-0">
                                    <component :is="item.icon" class="'text-gray-400 group-hover:text-gray-500 mr-4 flex-shrink-0 h-6 w-6" aria-hidden="true" />
                                </div>
                                <div class="block text-sm font-medium text-gray-900">
                                    {{ item.title }}
                                </div>
                            </div>
                        </div>
                        <CheckCircleIcon :class="[!item.checked ? 'invisible' : '', 'h-5 w-5 text-indigo-600']" aria-hidden="true" />
                        <div :class="[item.active ? 'border' : 'border-2', item.checked ? 'border-indigo-500' : 'border-transparent', 'absolute -inset-px rounded-lg pointer-events-none']" aria-hidden="true" />
                    </div>
                </div>
            </div>
        </div>
</template>

<script>
import { RadioGroup, RadioGroupDescription, RadioGroupLabel, RadioGroupOption } from '@headlessui/vue'
import { CheckCircleIcon } from '@heroicons/vue/24/solid'
import {
    DevicePhoneMobileIcon,
    CalendarIcon,
    ClockIcon,
    ChartBarIcon,
    GlobeAltIcon,
    MapPinIcon
} from '@heroicons/vue/24/outline'

export default {
    components: {
        RadioGroup,
        RadioGroupDescription,
        RadioGroupLabel,
        RadioGroupOption,
        CheckCircleIcon,
        DevicePhoneMobileIcon,
        CalendarIcon,
        ClockIcon,
        ChartBarIcon,
        GlobeAltIcon,
        MapPinIcon
    },

    props: {
        checkedFilter: {
            default: null
        },
        excludedFilters: {
            default: []
        }
    },

    mounted() {
        if (this.checkedFilter) {
            const filter = this.types.find(t => t.id === this.checkedFilter)
            if (filter) {
                filter.checked = true
            }
        }
    },

    computed: {
        filteredTypes() {
            return this.types.filter(t => this.excludedFilters.findIndex(f => f.type === t.id) === -1)
        }
    },

    methods: {
        toggleType(item) {
            this.types.forEach(type => {type.checked = false})

            item.checked = true

            let selectedFilters = []

            if (item.checked) {
                selectedFilters = [item.id]
            } else {
                selectedFilters = []
            }

            this.$emit('changed', item.id)
        }
    },


    data() {
        return {
            types: [
                { id: 'device', title: 'Устройства', icon: DevicePhoneMobileIcon, checked: false },
                { id: 'day', title: 'День', icon: CalendarIcon, checked: false },
                { id: 'time', title: 'Время', icon: ClockIcon, checked: false },
                { id: 'scans-count', title: 'Cканирования', icon: ChartBarIcon, checked: false },
                { id: 'language', title: 'Язык', icon: GlobeAltIcon, checked: false },
                { id: 'location', title: 'Локация', icon: MapPinIcon, checked: false },
            ]
        }
    },
}
</script>
